module.exports = __webpack_public_path__ + "img/5-1.72fb9116.svg";